/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { getLPTokenFromGauge, supportedGauges } from '../helpers/supportedContracts';
export var Stake = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'deposit',
    name: 'deposit_LP_tokens',
    description: 'Deposit LP tokens into the gauge.',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_gauge',
                    options: supportedGauges.filter(function (pool) { return pool.chainId === Number(chainId); }),
                }),
                methodParams: {
                    amount: new FctValue({ destination: 'wei_amount', decimals: 18 }),
                    receiver: new FctAddress({}),
                },
            },
            output: {},
        });
    },
    requiredApprovals: function (params, chainId) {
        var toAddress = (params === null || params === void 0 ? void 0 : params.to.value) && typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string'
            ? getLPTokenFromGauge(chainId, params === null || params === void 0 ? void 0 : params.to.value)
            : undefined;
        if (!toAddress)
            return [];
        return [
            {
                to: toAddress,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
